import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

//Images
// import aviator from "../../../src/assets/img/mobile/Aviator.svg"
import league from "../../../src/assets/img/mobile/League.svg";

//SVGs
// import soccer from "../../assets/svg/sports/Soccer.svg"
import comet from "../../assets/svg/comet-crash.svg";
import casino1 from "../../assets/img/mobile/Casino.svg";
import jackpot from "../../assets/img/mobile/Jackpot.svg";
import promo from "../../assets/svg/fire.svg";
import aviator from "../../../src/assets/img/aviator.webp";
import jetX from "../../../src/assets/img/mobile/jet.svg";
import crash from "../../../src/assets/img/mobile/crash.svg";

import { getFromLocalStorage } from "../utils/local-storage";
import useAnalyticsEventTracker from "../analytics/useAnalyticsEventTracker";
import { StoreContext } from "../../context/store";

import { LazyLoadImage } from "react-lazy-load-image-component";
import { useDispatch, useSelector } from "react-redux";
import { setState } from "../../redux/dataSlice";
import { matchCategories } from "../../redux/matchesSlice";

const MobileNav1 = React.memo(() => {
  const { state } = useContext(StoreContext);

  const scrollContainerRef = useRef(null);

  const firstItemRef = useRef(null);

  const gaEventTracker = useAnalyticsEventTracker("Navigation");

  const dispatchRedux = useDispatch();

  const pathname = window.location.pathname;

  const availableCategories = useSelector(
    (state) => state.matchesData.sport_categories
  );
  const [competitions, setCompetitions] = useState(
    getFromLocalStorage("sport_categories")
  );
  const isFetching = useSelector((state) => state.matchesData.isFetching);

  const active_link = useSelector((state) => state.data.active_link);

  const userData = useSelector((state) => state.auth.user);
  const [user, setUser] = useState(getFromLocalStorage("user"));
  let sportId =
    new URLSearchParams(window.location.search).get("sport_id") || "79";

  useEffect(() => {
    if (userData) {
      setUser(userData || getFromLocalStorage("user"));
    }
  }, [userData]);

  useEffect(() => {
    if (availableCategories) {
      setCompetitions(
        availableCategories || getFromLocalStorage("sport_categories")
      );
    } else if (!isFetching) {
      // Fetch data if it's not currently being fetched
      dispatchRedux(matchCategories(sportId));
    }
  }, [availableCategories, isFetching, dispatchRedux]);

  const setActiveLink = (link) => {
    dispatchRedux(setState("active_link", link));
    dispatchRedux(matchCategories(link));
  };

  // useEffect(() => {
  //     setCompetitions(availableCategories||getFromLocalStorage("sport_categories"))

  // }, [availableCategories])

  const getDefaultMarketsForSport = (allsports) => {
    return allsports?.default_display_markets;
  };

  const getSportImageIcon = (
    sport_name,
    folder = "sports",
    topLeagues = false
  ) => {
    let default_img = "default_sport";
    let sport_image;
    try {
      sport_image = topLeagues
        ? require(`../../../src/assets/${sport_name}`)
        : require(`../../../src/assets/svg/${folder}/${sport_name}.svg`);
    } catch (error) {
      sport_image = require(`../../../src/assets/svg/${folder}/${default_img}.svg`);
    }
    return sport_image;
  };
  const navigate = useNavigate();
  let url = new URL(window.location.href);
  let sport_id = url.searchParams.get("sport_id");

  useEffect(() => {
    setActiveLink(sport_id ? sport_id : 79);
  }, []);

  // Ensure competitions is an object with the expected structure
  const selectedSport = Array.isArray(competitions?.all_sports)
    ? competitions.all_sports.filter(
        (allsports) => Number(allsports?.sport_id) === Number(active_link)
      )
    : [];

  const launchAviator = (status) => {
    const gameUrl = btoa("/v1/spribe-game-url");
    const demo_url = btoa(
      `https://demo.spribe.io/launch/aviator?currency=KES&lang=EN&return_url=https://betnare.com`
    );

    if (status === "demo") {
      navigate(
        `/play-game?game_id=aviator&status=0&provider=Spribe&game_url=${gameUrl}&demo_url=${demo_url}`
      );
    } else {
      navigate(
        `/play-game?game_id=aviator&status=1&provider=Spribe&game_url=${gameUrl}&demo_url=${demo_url}`
      );
    }
  };

  const scrollToFirstItem = () => {
    if (firstItemRef.current) {
      firstItemRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <div className="menu-wrapper mobile-nav-remove ">
      <table
        className="menu-table"
        style={{ width: "100%", textAlign: "center", marginLeft: "-9px" }}
      >
        <tbody>
          <tr className={"tr-style mobile-nav-top"}>
            <td
              ref={firstItemRef}
              className={`menu-t m-auto sport-check  ${
                pathname === "/" ||
                Number(active_link) === selectedSport[0]?.sport_id
                  ? "active_link"
                  : "link-inactive"
              }`}
            >
              <div
                className={`inner-div more-sports cg ox anl url-link d-flex flex-column align-items-center `}
                onClick={() => {
                  gaEventTracker(
                    `Visit ${state?.active_sport}/${state?.active_sport_name}  Page`
                  );
                  setActiveLink(selectedSport[0]?.sport_id);
                  navigate(
                    `/highlights?sport_id=${
                      selectedSport[0]?.sport_id
                    }&sub_type_id=${getDefaultMarketsForSport(
                      selectedSport[0]
                    )}&sport_name=${selectedSport[0]?.sport_name}`
                  );
                }}
              >
                <div className="inner-div cg ox anl url-link d-flex flex-column align-items-center">
                  <div className="menu-img">
                    <LazyLoadImage
                      className="side-icon"
                      src={getSportImageIcon(selectedSport[0]?.sport_name)}
                      alt=""
                      effect="blur"
                      style={{ height: "23px", marginTop: "-1px" }}
                    />
                  </div>
                  <p style={{ textAlign: "center", marginBottom: "unset" }}>
                    {selectedSport[0]?.sport_name}
                  </p>
                </div>
              </div>
            </td>

            <td
              className={`menu-t m-auto sport-check ${
                "/nare-games/aviator" === active_link
                  ? " active_link"
                  : "link-inactive"
              }`}
            >
              <div
                className={`inner-div more-sports cg  ox anl url-link d-flex flex-column align-items-center `}
                onClick={() => {
                  gaEventTracker("Visit Aviator Page");
                  launchAviator(user ? "live" : "demo");
                  setActiveLink("/nare-games/aviator");
                }}
              >
                <div
                  className={`inner-div  cg  ox anl url-link d-flex flex-column align-items-center `}
                >
                  <div className="menu-img ">
                    <LazyLoadImage
                      className="side-icon "
                      src={aviator}
                      alt=""
                      style={{
                        height: "26px",
                        marginTop: "-1px",
                        width: "41px",
                      }}
                    />
                  </div>
                  <p style={{ textAlign: "center", marginBottom: "unset" }}>
                    Aviator
                  </p>
                </div>
              </div>
            </td>

            <td
              className={`menu-t m-auto sport-check ${
                "crashgames" === active_link ? " active_link" : "link-inactive"
              }`}
            >
              <div
                className={`inner-div more-sports cg  ox anl url-link d-flex flex-column align-items-center `}
                onClick={() => {
                  gaEventTracker("Visit  Crash Page");
                  navigate("/crashgames/crash_games");

                  setActiveLink("/crashgames/crash_games");
                }}
              >
                <div
                  className={`inner-div  cg  ox anl url-link d-flex flex-column align-items-center `}
                >
                  <div className="menu-img ">
                    <LazyLoadImage
                      className="side-icon "
                      src={comet}
                      alt=""
                      style={{
                        height: "26px",
                        marginTop: "2px",
                        width: "41px",
                      }}
                    />
                    <span className=" hot-alert-badge">HOT</span>
                  </div>
                  <p style={{ textAlign: "center", marginBottom: "unset" }}>
                    Crash
                  </p>
                </div>
              </div>
            </td>

            <td
              className={`menu-t m-auto sport-check ${
                "virtualgames" === active_link
                  ? " active_link"
                  : "link-inactive"
              }`}
            >
              <div
                className={`inner-div more-sports cg  ox anl url-link d-flex flex-column align-items-center `}
                onClick={() => {
                  gaEventTracker("Visit  Crash Page");
                  navigate("/virtualgames/virtual_games");

                  setActiveLink("/virtualgames/virtual_games");
                }}
              >
                <div
                  className={`inner-div  cg hot-alert ox anl url-link d-flex flex-column align-items-center  `}
                >
                  <div className="menu-img  ">
                    <LazyLoadImage
                      className="side-icon"
                      src={league}
                      alt=""
                      effect="blur"
                      style={{ height: "24px", marginTop: "-1px" }}
                    />
                  </div>
                  <p style={{ textAlign: "center", marginBottom: "unset" }}>
                    Virtuals
                  </p>
                </div>
              </div>
            </td>

            <td
              className={`menu-t m-auto sport-check ${
                "/jackpot" === active_link ? "active_link" : "link-inactive"
              } `}
            >
              <div
                className={`inner-div more-sports  cg  ox anl url-link d-flex flex-column align-items-center  `}
                onClick={() => {
                  navigate("/jackpot");
                  gaEventTracker("Visit Jackpot Page");
                  setActiveLink("/jackpot");
                }}
              >
                <div
                  className={`inner-div  cg  ox anl url-link d-flex flex-column align-items-center`}
                >
                  <div className="menu-img ">
                    <LazyLoadImage
                      className="side-icon "
                      src={jackpot}
                      alt=""
                      effect="blur"
                      style={{ height: "32px", marginTop: "-3px" }}
                    />
                  </div>
                  <p style={{ textAlign: "center", marginBottom: "unset" }}>
                    Jackpot
                  </p>
                </div>
              </div>
            </td>

            <td
              className={`menu-t m-auto sport-check ${
                "/casino" === active_link ? " active_link" : "link-inactive"
              } `}
            >
              <div
                className={`inner-div more-sports  cg  ox anl url-link d-flex flex-column align-items-center `}
                onClick={() => {
                  gaEventTracker("Visit Casino Page");
                  navigate("/casino");
                  setActiveLink("/casino");
                }}
              >
                <div
                  className={`inner-div  cg  ox anl url-link d-flex flex-column align-items-center `}
                >
                  <div className="menu-img ">
                    <LazyLoadImage
                      className="side-icon"
                      src={casino1}
                      alt=""
                      effect="blur"
                      style={{ height: "29px", marginTop: "-2px" }}
                    />
                  </div>
                  <p style={{ textAlign: "center", marginBottom: "unset" }}>
                    Casino
                  </p>
                </div>
              </div>
            </td>

            {/* Other Sports Section */}
            {competitions?.all_sports.map((allsports, index) => {
              return (
                allsports?.sport_id !== selectedSport[0]?.sport_id && (
                  <td
                    key={index}
                    className={`menu-t m-auto sport-check ${
                      Number(active_link) === Number(allsports?.sport_id)
                        ? "active_link"
                        : "link-inactive"
                    }`}
                  >
                    <div
                      className={`inner-div more-sports cg ox anl url-link d-flex flex-column align-items-center `}
                      onClick={() => {
                        gaEventTracker(
                          `Visit ${state?.active_sport}/${state?.active_sport_name}  Page`
                        );
                        setActiveLink(allsports?.sport_id);
                        scrollToFirstItem();
                        navigate(
                          `/highlights?sport_id=${
                            allsports.sport_id
                          }&sub_type_id=${getDefaultMarketsForSport(
                            allsports
                          )}&sport_name=${allsports.sport_name}`
                        );
                      }}
                    >
                      <div className="inner-div cg ox anl url-link d-flex flex-column align-items-center">
                        <div className="menu-img">
                          <LazyLoadImage
                            className="side-icon"
                            src={getSportImageIcon(allsports?.sport_name)}
                            alt=""
                            effect="blur"
                            style={{ height: "23px", marginTop: "-1px" }}
                          />
                        </div>
                        <p
                          style={{ textAlign: "center", marginBottom: "unset" }}
                        >
                          {allsports?.sport_name}
                        </p>
                      </div>
                    </div>
                  </td>
                )
              );
            })}

            {/* Promo */}
            <td
              className={`menu-t m-auto sport-check ${
                "/promotions" === active_link ? "active_link" : "link-inactive"
              } `}
            >
              <div
                className={`inner-div more-sports cg  ox anl url-link d-flex flex-column align-items-center `}
                onClick={() => {
                  gaEventTracker("Visit Promotion Page");
                  setActiveLink("/promotions");
                  navigate(`/promotions`);
                }}
              >
                <div
                  className={`inner-div  cg  ox anl url-link d-flex flex-column align-items-center `}
                >
                  <div className="menu-img ">
                    <LazyLoadImage
                      className="side-icon"
                      src={promo}
                      alt=""
                      effect="blur"
                      style={{ height: "23px", marginTop: "-6px" }}
                    />
                    <span className="badge rounded-pill bg-warning text-dark promo-count ">
                      8
                    </span>
                  </div>
                  <p style={{ textAlign: "center", marginBottom: "unset" }}>
                    Promo
                  </p>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
});

export default React.memo(MobileNav1);
